import React from 'react'
import {Message, Button} from 'semantic-ui-react'
import {getLanguageScope} from "../../../../helpers";

const _i18n = getLanguageScope('scanner');

class Scanner extends React.Component {
  constructor(props) {
    super(props);
  }

  async componentDidMount() {
    const {startScan, disconnectProcessing, scanType} = this.props;

    disconnectProcessing(false);

    startScan && startScan(scanType);
  }


  componentWillUnmount(){
    const {disconnect} = this.props;

    disconnect && disconnect()
  }


  render() {
    const {scanner_server_status} = this.props;

    if(scanner_server_status) return null;

    return null;

    // return (
    //   <Message info>
    //     <Message.Header>{_i18n('scanner_download_title')}</Message.Header>
    //     <Button onClick={() => window.open('/maya_otc.exe')} style={{margin: '10px 0 5px 0'}} content={_i18n('scanner_download_button')} color='blue' icon='download' labelPosition='left' />
    //     <Message.Content>{_i18n('scanner_download_content')}</Message.Content>
    //   </Message>
    // );
  }
}

export default Scanner;


// WEBPACK FOOTER //
// ./src/components/Devices/Scanner/components/Scanner.js